import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@shigo-ui/ui';

import { NetworkBrandingProvider } from './components/branding/NetworkBrandingProvider';
import { router } from './router';
import { ShigoSessionProvider } from './lib/session';
import { ShigoThemeProvider } from './lib/theme';

export function App() {
  return (
    <ShigoThemeProvider>
      <ShigoSessionProvider>
        <NetworkBrandingProvider>
          <RouterProvider router={router} />
        </NetworkBrandingProvider>
        <Toaster richColors position="bottom-right" />
      </ShigoSessionProvider>
    </ShigoThemeProvider>
  );
}
